import { render, staticRenderFns } from "./lead_times_table.vue?vue&type=template&id=070544e0&scoped=true&"
import script from "./lead_times_table.vue?vue&type=script&lang=js&"
export * from "./lead_times_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070544e0",
  null
  
)

export default component.exports